/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Result_Action_Table_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Pick a table" |
*
* @param {Agent_Builder_Result_Action_Table_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_result_action_table_placeholder = /** @type {((inputs?: Agent_Builder_Result_Action_Table_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Result_Action_Table_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tabelle auswählen")
	return /** @type {LocalizedString} */ ("Pick a table")
});